import { ConnecterdPrintPopup } from '@components/ConnectedPrinterPopup';
import { HoverSmallFile } from '@components/FileUpload';
import PermissionTooltip from '@components/PermissionTooltip';
import { Button } from '@skupreme/shared/ui';
import useUrlPermission from '@hooks/url-permission';
import { Plus } from '@phosphor-icons/react';
import { CommonUtility } from '@utility/common';
import { useMemo, useState } from 'react';

function DocumentField({
  documents,
  field,
  actionAllowed,
  className,
  disabled,
  removeDocument,
  setPrintFile,
  hidden,
  uploadDocument,
  allowPrint,
}) {
  const filterDocuments = useMemo(() => {
    return documents?.filter(x => {
      const documentType = x.documentType || x.document_type;
      const fieldDocumentType = field.documentType || field.name;

      return fieldDocumentType === documentType;
    });
  }, [documents, field]);

  if (
    !(actionAllowed && field.allowUpload) &&
    !CommonUtility.isValidArray(filterDocuments)
  ) {
    return <></>;
  }

  return (
    <div
      key={field.name}
      className={`sk:flex sk:flex-wrap sk:gap-2.5 ${className}`}
    >
      {filterDocuments.map(file => (
        <HoverSmallFile
          key={file.key}
          file={{
            ...file,
            file_type: file.file_type || file.fileType,
            file_name: file.file_name || file.fileName,
          }}
          colClass="sk:w-full"
          actionAllowed={actionAllowed && field.allowUpload && !disabled}
          removeDocument={() => removeDocument(file.key)}
          // @ts-expect-error - TS2322: Type '{ key: any; file: any; colClass: string; actionAllowed: any; removeDocumen...
          printDocument={allowPrint ? () => setPrintFile(file.filePath) : null}
        />
      ))}
      {actionAllowed && field.allowUpload && (
        <PermissionTooltip
          disabled={disabled}
          hidden={hidden}
          position="bottom center"
          wrapperClassName="sk:flex sk:w-full"
        >
          <Button
            variant="danger"
            className="sk:max-w-full sk:flex-1 sk:justify-between sk:border-dashed"
            onPress={() => uploadDocument(field)}
            isDisabled={disabled}
          >
            <span>{field.label || 'Additional Documents'}</span>
            <Plus className="sk:ml-5!" size={18} />
          </Button>
        </PermissionTooltip>
      )}
    </div>
  );
}

export function DynamicFieldUploadV2({
  fields,
  documents,
  removeDocument,
  uploadDocument,
  actionAllowed,
  allowPrint = true,
  className,
}) {
  const { disabled, hidden } = useUrlPermission();
  const [printFile, setPrintFile] = useState('');

  return (
    <>
      {fields.map(field => (
        <DocumentField
          field={field}
          disabled={disabled}
          documents={documents}
          actionAllowed={actionAllowed}
          setPrintFile={setPrintFile}
          hidden={hidden}
          className={className}
          uploadDocument={uploadDocument}
          removeDocument={removeDocument}
          allowPrint={allowPrint}
        />
      ))}
      <ConnecterdPrintPopup
        closeModal={() => setPrintFile('')}
        doneClick={() => setPrintFile('')}
        open={!!printFile}
        url={printFile}
      />
    </>
  );
}
